import { FlagGatedSection } from '@/features/campaign-whatsapp-ai-config/flag-gated-section'
import { WhatsAppAiConfigPanel } from '@/features/campaign-whatsapp-ai-config/whatsapp-ai-config-panel'
import { useBooleanFlagValue } from '@openfeature/react-sdk'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/company/$companyId/$campaignId/settings/whatsapp-ai')({
	component: RouteComponent,
})

function RouteComponent() {
	const { companyId, campaignId } = Route.useParams()
	const enabled = useBooleanFlagValue('whatsapp-ai-agent', false)

	return (
		<FlagGatedSection enabled={enabled} companyId={companyId} campaignId={campaignId}>
			<WhatsAppAiConfigPanel companyId={companyId} campaignId={campaignId} />
		</FlagGatedSection>
	)
}
